function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "478.425 18.525 14.45 14.475",
    width: "16.3556px",
    height: "16.4194px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id2_s6ez352dw",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 2.842170943040401e-14, -3.552713678800501e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.6,33c-0.3,0-0.6-0.1-0.8-0.4l-12-12c-0.5-0.5-0.5-1.2,0-1.7c0.5-0.5,1.2-0.5,1.7,0l12,12 c0.5,0.5,0.5,1.2,0,1.7C492.2,32.8,491.9,33,491.6,33z",
    style: {
      fill: "rgb(20, 18, 35)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "__id3_s6ez352dw",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 2.842170943040401e-14, -3.552713678800501e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.6,33c-0.3,0-0.6-0.1-0.8-0.4c-0.5-0.5-0.5-1.2,0-1.7l12-12c0.5-0.5,1.2-0.5,1.7,0 c0.5,0.5,0.5,1.2,0,1.7l-12,12C480.2,32.8,479.9,33,479.6,33z",
    style: {
      fill: "rgb(20, 18, 35)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.033e59015daaa6cc0e6dc6313a6df9ad.svg";
export { ForwardRef as ReactComponent };